import { Component, Input, OnInit } from "@angular/core";
import { NavParams } from "ionic-angular";
import moment from "moment";
import ContentWrapper from "../../../../models/content-wrapper/content-wrapper";
import { OrderDataService } from "../../../../providers/order-data-service/order-data-service";
import { UtilityService } from "../../../../providers/utility-service/utility-service";

/**
 * Generated class for the Visit Frequency list item component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "visit-frequency-list-item",
  templateUrl: "visit-frequency-list-item.html",
})
export class VisitFrequencyListItem implements OnInit {
  @Input() patientId: string;
  @Input() initialData: ContentWrapper<Object>;
  colHeaders = [];
  orderTypeOptions = [];
  categoryOptions = [];
  diagnosisTypeEnums = [];
  roleEnums = [];
  dataPages = [];
  totalPageCount: number;
  visitFreqTotalCount: number;
  pageSize: any = 5;
  currentPage: any = 0;

  constructor(
    public navParams: NavParams,
    private orderService: OrderDataService,
    public utilityService: UtilityService
  ) {}

  ngOnInit(): void {
    this.getEnums();
    this.colHeaders = [
      "Discipline",
      "Visit(s)",
      "Time Interval",
      "PRN Visit(s)",
      "Reason",
      "Start Date",
      "End Date",
    ];
    this.paginateData(this.initialData);
  }

  getActiveOrders() {
    this.orderService
      .getVisitFrequencyActiveOrders(
        this.patientId,
        this.pageSize,
        this.currentPage
      )
      .subscribe(
        (data) => {
          this.paginateData(data);
        },
        (err) => {
          console.error(err);
        }
      );
  }

  paginateData(response: ContentWrapper<Object>) {
    this.dataPages = response["content"];
    this.totalPageCount = response.totalPages;
    this.visitFreqTotalCount = response.totalElements;
    this.currentPage = response.pageable.pageNumber;
  }

  firstPage() {
    if (this.currentPage) {
      this.currentPage = 0;
      this.changePage();
    }
  }

  prevPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.changePage();
    }
  }

  setPage(page) {
    if (page >= 0 && page <= this.totalPageCount && page !== this.currentPage) {
      this.currentPage = page;
      this.changePage();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPageCount - 1) {
      this.currentPage++;
      this.changePage();
    }
  }

  lastPage() {
    if (this.currentPage !== this.totalPageCount - 1) {
      this.currentPage = this.totalPageCount - 1;
      this.changePage();
    }
  }

  changePage() {
    this.orderService
      .getVisitFrequencyActiveOrders(
        this.patientId,
        this.pageSize,
        this.currentPage
      )
      .subscribe(
        (response) => {
          this.paginateData(response);
        },
        (err) => {
          console.error(err);
        }
      );
  }

  getEnums() {
    this.orderService.getOrderCategoryEnums().subscribe(
      (data) => {
        Object.keys(data).forEach((category) => {
          this.categoryOptions.push({
            display: data[category].display,
            value: category,
          });
        });
        this.categoryOptions.sort((a, b) => {
          return a.display.localeCompare(b.display);
        });
      },
      (err) => {
        this.utilityService.presentErrorToast(
          err,
          "Error retrieving category data"
        );
      }
    );
    this.orderService.getOrderTypeEnums().subscribe(
      (data) => {
        Object.keys(data).forEach((type) => {
          this.orderTypeOptions.push({
            display: data[type].display,
            value: type,
          });
        });
        this.orderTypeOptions.sort((a, b) => {
          return a.display.localeCompare(b.display);
        });
      },
      (err) => {
        this.utilityService.presentErrorToast(
          err,
          "Error retrieving order type data"
        );
      }
    );
    this.orderService.getRoleEnums().subscribe(
      (data) => {
        Object.keys(data).forEach((role) => {
          this.roleEnums.push({ display: data[role].display, value: role });
        });
        this.roleEnums.sort((a, b) => {
          return a.display.localeCompare(b.display);
        });
        console.log("Role Enums Loaded", this.roleEnums);
      },
      (err) => {
        this.utilityService.presentErrorToast(err, "Error role data");
      }
    );
    this.orderService.getDiagnosisEnums().subscribe(
      (data) => {
        Object.keys(data).forEach((diagnosis) => {
          this.diagnosisTypeEnums.push({
            display: data[diagnosis].display,
            value: diagnosis,
          });
        });
        this.roleEnums.sort((a, b) => {
          return a.display.localeCompare(b.display);
        });
      },
      (err) => {
        this.utilityService.presentErrorToast(err, "Error role data");
      }
    );
  }
  displayRole(item): string {
    if (this.roleEnums.length > 0) {
      let roleEnum = this.roleEnums.find((role) => {
        return role.value === item.orderTypeDetails.role;
      });
      if (roleEnum) {
        if (roleEnum.value === "OTH")
          return `Other -  ${item.orderTypeDetails.otherRole}`;
        return roleEnum.display;
      }
    }
    return item.role;
  }

  convertDate(input) {
    let localDate = this.utilityService.covertDatetoLocalFormat(input);
    let date = moment(localDate).format("MM/DD/YYYY");
    return date === "Invalid date" ? "-" : date;
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/visit-frequency-list-item/visit-frequency-list-item.ts